import { LoadPositionsImp, LoadPositionsUsecase } from 'domain/usecases/load-positions-usecase';
import { makeCryptoPositionRepository } from '../repositories/ws/position-ws-repository-factory';

export const makeCryptoLoadPositions = (): LoadPositionsUsecase => {
  return new LoadPositionsImp(makeCryptoPositionRepository());
};
